import { render, staticRenderFns } from "./ChoosePlatformField.vue?vue&type=template&id=5f82966e"
import script from "./ChoosePlatformField.vue?vue&type=script&lang=js"
export * from "./ChoosePlatformField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports